import CONFIG from '../config'
import axios from 'axios'

export default function checkProtectedPagePassword ({ id = '', password = '' }) {
  // console.log(`${CONFIG.API_URL}/wp/v2/pages/${id}?password=${password}`)
  return new Promise((resolve, reject) => {
    return axios.get(`${CONFIG.API_URL}/wp/v2/pages/${id}?password=${password}`)
    .then(response => {
      resolve(response.status)
    })
    .catch(response => reject(response))
  })
}



// WEBPACK FOOTER //
// ./client/api/checkProtectedPagePassword.js